import * as React from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import { Stack } from "@mui/system";

export default function DisplayCard({ data }) {
  return (
    <Card
      sx={{
        width: 300,
        height: 550,
        borderRadius: "25px",
        backgroundColor: "primary.light",
        boxShadow: "#dad2cb 12px 12px 24px",
        border: "2px solid black",
      }}
    >
      <CardContent>
        <Stack
          direction="column"
          justifyContent="space-between"
          alignItems="center"
          spacing={2}
        >
          <Typography variant="h5">Class {data.studentClass}th</Typography>
          <Typography variant="h5">Topper {data.session}</Typography>
          <img
            src={data.image}
            alt="Topper"
            style={{
              height: 220,
              width: "100%",
              objectFit: "contain",
            }}
          />
          <Typography variant="body1">{data.name}</Typography>
          {data.maths && (
            <Typography variant="body1">{"Maths : " + data.maths}</Typography>
          )}
          {data.science && (
            <Typography variant="body1">
              {"Science : " + data.science}
            </Typography>
          )}
          {data.phy && (
            <Typography variant="body1">{"Physics : " + data.phy}</Typography>
          )}
          {data.chem && (
            <Typography variant="body1">
              {"Chemistry : " + data.chem}
            </Typography>
          )}
          <Typography variant="body1">{data.school}</Typography>
        </Stack>
      </CardContent>
    </Card>
  );
}
